import type { ExecutionContext } from "../runtime/context.js";

export function handleContextShow(context: ExecutionContext) {
  return {
    branch: context.branch,
    cwd: context.cwd,
    gitDir: context.gitDir,
    isGitRepo: context.isGitRepo,
    projectRoot: context.projectRoot,
    storageRoot: context.storageRoot,
  };
}
